module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f2-300x300.acd7bf9f.webp";